export default "__VITE_ASSET__CPCJhduQ__"